import classNames from 'classnames'
import { memo, useCallback, useMemo } from 'react'
import { FaUserGroup } from 'react-icons/fa6'
import { useShallow } from 'zustand/react/shallow'
import { useGetMyProfileMini } from '../../../../../../hooks/queries/profile/use-get-my-profile-mini'
import { useGlobalStore } from '../../../../../../store/global-store'
import { ALLOW_SEND_FOR_ME, useGetDataSeats } from '../use-get-data-seats'

export const SelectAll = memo(() => {
  const { streamerId, typeLive, userIdToSendGift, isSelectedAll } =
    useGlobalStore(
      useShallow((state) => ({
        // live: state.live,
        streamerId: state.liveUserId,
        typeLive: state.typeLive,
        userIdToSendGift: state.userIdToSendGift,
        isSelectedAll: state.isSelectedAll,
      })),
    )

  const { user: userGlobal } = useGetMyProfileMini()

  const { dataSeats } = useGetDataSeats()

  const isStreamer = useMemo(() => {
    return Number(streamerId) === Number(userGlobal?.id)
  }, [streamerId, userGlobal?.id])

  const handleSelectAll = useCallback(() => {
    const liveUserId = ALLOW_SEND_FOR_ME
      ? streamerId
      : !isStreamer && streamerId

    if (!typeLive?.includes('multi')) {
      return useGlobalStore.setState(() => {
        const data = new Set<number>()

        data.add(liveUserId as number)

        if (userIdToSendGift) {
          data.add(userIdToSendGift)
        }

        return {
          usersToGift: data,
          isSelectedAll: true,
        }
      })
    }

    dataSeats
      .filter((user) => {
        const userId = user?.userId

        return ALLOW_SEND_FOR_ME
          ? !!userId
          : !!userId && Number(userId) !== Number(userGlobal?.id)
      })
      .forEach((user) => {
        return useGlobalStore.setState((state) => {
          const newSet = new Set(state.usersToGift)

          newSet.add(liveUserId as number)
          newSet.add(user?.userId)

          return {
            usersToGift: newSet,
          }
        })
      })

    useGlobalStore.setState({ isSelectedAll: true })
  }, [
    streamerId,
    dataSeats,
    userIdToSendGift,
    isStreamer,
    userGlobal?.id,
    typeLive,
  ])

  const handleClearUsersToGift = useCallback(() => {
    useGlobalStore.setState({ isSelectedAll: false })
    useGlobalStore.setState({ usersToGift: new Set() })
  }, [])

  return (
    typeLive?.includes('multi') && (
      <div
        className={classNames(
          'rounded-full flex w-10 h-10 items-center justify-center text-white',
          {
            'border-2 border-purple-600': isSelectedAll,
          },
        )}
        onClick={isSelectedAll ? handleClearUsersToGift : handleSelectAll}
      >
        <FaUserGroup />
      </div>
    )
  )
})
